import { useLazyQuery } from "@apollo/client"
import { TOURNAMENT_PLAYER_BY_CODE } from "../queries/tournamentPlayerByCode"

interface QueryResult {
  TournamentPlayerByCode: {
    status: { success: boolean; name: string; detail: string }
    personId: number
    tournamentPlayerId: number
  }
}

export const useTournamentPlayerByCode = () => {
  const [fetchPlayerByCode, { loading }] = useLazyQuery<QueryResult>(TOURNAMENT_PLAYER_BY_CODE, {
    fetchPolicy: "network-only",
  })

  const findPlayerByCode = async (tournamentId: number, code: string) => {
    const { data } = await fetchPlayerByCode({ variables: { input: { tournamentId, code } } })
    const result = data?.TournamentPlayerByCode
    if (!result?.status?.success || !result.personId) return null
    return { personId: result.personId, tournamentPlayerId: result.tournamentPlayerId }
  }

  return { findPlayerByCode, loading }
}
